import webConfig from "/src/config/app";

let scriptLoadingPromise = null;

function loadRecaptchaScript() {
  if (window.grecaptcha && window.grecaptcha.render) {
    return Promise.resolve(window.grecaptcha);
  }

  if (scriptLoadingPromise) {
    return scriptLoadingPromise;
  }

  scriptLoadingPromise = new Promise((resolve, reject) => {
    // render=explicit : on affiche le widget nous-même, quand le container
    // du formulaire est monté, plutôt que de laisser Google le faire au
    // chargement de la page.
    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js?render=explicit";
    script.async = true;
    script.defer = true;
    script.onload = () => window.grecaptcha.ready(() => resolve(window.grecaptcha));
    script.onerror = () => reject(new Error("Impossible de charger reCAPTCHA."));
    document.head.appendChild(script);
  });

  return scriptLoadingPromise;
}

/**
 * Affiche le widget reCAPTCHA v2 ("case à cocher") dans le container donné.
 * Retourne l'id du widget, à réutiliser pour lire ou réinitialiser sa réponse.
 */
async function renderRecaptcha(container) {
  const grecaptcha = await loadRecaptchaScript();
  return grecaptcha.render(container, {
    sitekey: webConfig.recaptchaSiteKey,
  });
}

/**
 * Renvoie le jeton de la case cochée/du défi résolu, ou une chaîne vide si
 * l'utilisateur n'a pas (encore) validé le widget.
 */
function getRecaptchaResponse(widgetId) {
  if (!window.grecaptcha) {
    return "";
  }
  return window.grecaptcha.getResponse(widgetId);
}

/**
 * Réinitialise le widget : la case se décoche et un nouveau défi devra être
 * résolu. À appeler après chaque tentative de soumission (succès ou échec)
 * pour qu'un jeton ne puisse jamais être réutilisé.
 */
function resetRecaptcha(widgetId) {
  if (!window.grecaptcha) {
    return;
  }
  window.grecaptcha.reset(widgetId);
}

export { renderRecaptcha, getRecaptchaResponse, resetRecaptcha };
